<template>
  <div id="app">
    <div id="container">
      <dragTreeTable
        class="treeTable"
        ref="table"
        :data="treeData"
        :onDrag="onTreeDataChange"
        fixed
        :isdraggable="true"
      ></dragTreeTable>
      <ContextMenu :onMenu="onMenu" ref="editDialog"></ContextMenu>
      <!-- <ContextMenu :onSave="onAdd" ref="addDialog"></ContextMenu> -->
    </div>
  </div>
</template>

<script>
import dragTreeTable from "../lib/dragTreeTable.vue";
import DialogDiv from "./dialog.vue";
import ContextMenu from "./contextMenu.vue";
import demoDataList from './data';

import { getWholeTree, addNode, removeNode, moveNode } from "./treeTableAPI";

let rootidPara = '0e074edb38753a8a2346a8ad1b890f3e'

export default {
  name: "app",
  data () {
    return {
      demoDataList2: demoDataList,
      treeData: {
        columns: [],
        lists: []
      }
    };
  },
  components: {
    dragTreeTable,
    DialogDiv,
    ContextMenu
  },
  props: {

  },
  methods: {
    // onTreeDataChange(list) {
    //   console.log(list);
    //   this.treeData.lists = list;
    // }

    onTreeDataChange (lists, from, to, where) {

      // console.log(where);
      // console.log(lists);
      const pos = {
        top: '上面',
        bottom: '下面',
        center: '里面'
      }
      // alert('父id(' + from.parent_id + ')' + '序号：(' + from.order + '=' + to.order + ')' + from.name + '(' + from.id + ')' + '  拖拽到  ' + to.name + '(' + to.id + ')' + '的' + pos[where])
      // this.treeData.lists = lists; // 展现数据

      let dataPara2 = {
        index: from.order + 1,
        moveId: from.id,
        parentId: from.parent_id == 0 ? '' : from.parent_id,
        rootId: rootidPara
      }
      // console.log("cddd", dataPara2)

      moveNode(JSON.stringify(dataPara2)).then(res => {
        // 成功的话展现数据
        this.treeData.lists = lists; // 展现数据
        //getWholeTree(rootidPara)
      })
    }
    ,
    onAdd (pId, data) {
      this.$refs.table.AddRow(pId, data)
    },
    onMenu (id, data, typeid) {
      // console.log('原',data)
      if (typeid === 1) { // 添加
        let lists = this.$refs.table.AddRow(id, data)

        let datapara = {
          index: 1,
          mpttNode: { relationId: data.name, },
          parentId: id,
          rootId: rootidPara,
        };
        // console.log('请求addnode',  JSON.stringify(datapara))
        addNode(JSON.stringify(datapara))
          .then(res => {
            this.treeData.lists = lists; // 展现数据
            // getWholeTree(rootidPara)
          })
      } else if (typeid === 2) { // 编辑
        let lists = this.$refs.table.EditRow(id, data)
        // …… 保存数据
        this.treeData.lists = lists; // 展现数据
        //  getWholeTree(rootidPara)
      } else { // 删除
        const updatedLists = this.$refs.table.DelById(id)

        let dataPara = {
          id: id,
          rootId: rootidPara
        };
        removeNode(JSON.stringify(dataPara)).then(res => {
          // ……
          this.treeData.lists = updatedLists;
          // getWholeTree(rootidPara)
        })
      }
    },
    onDel (item) {
      const updatedLists = this.$refs.table.DelById(item.id)
      console.log("当前行的数据", updatedLists);
      this.treeData.lists = updatedLists;

      alert('本地删除成功')
    },
  },
  mounted () {
    var columns = [
      {
        type: "selection",
        title: "<a>菜单名称</a>",
        field: "name",
        width: 150,
        align: "left",
        titleAlign: "left",
        formatter: item => {
          return "<span>" + item.name + "</span>";
        }
      },
      {
        title: "ID",
        field: "id",
        width: 50,
        align: "center"
      },
      {
        title: "序号",
        field: "order",
        width: 50,
        align: "center"
      },
      {
        title: "操作",
        type: "action",
        flex: 1,
        align: "center",
        actions: [
          {
            text: "操作节点",
            onclick: (item) => {
              this.$refs.editDialog.show(item);
            },
            formatter: item => {
              return "<a># </a>";
            }
          }
          // ,
          // {
          //   text: "修改子节点",
          //   onclick: (item) => {
          //     this.$refs.editDialog.show('edit', item);
          //   },
          //   formatter: item => {
          //     return "<i>修改子节点 </i>";
          //   }
          // },
          // {
          //   text: "删除",
          //   onclick: this.onDel,
          //   formatter: item => {
          //     return "<i>删除</i>";
          //   }
          // }
        ]
      }
    ];
    let rootid = rootidPara
    getWholeTree(rootid).then(res => {
      // console.log("GG", res)
      let demoDataList = res
      this.treeData = {
        columns: columns,
        lists: demoDataList //  getWholeTree() // demoDataList
      };
      // console.log("大雨", this.treeData, this.demoDataList2)
    })

    // this.$nextTick(()=>{
    //   this.treeData = {
    //     columns: columns,
    //     lists: demoDataList //  getWholeTree() // demoDataList
    //   };
    // })
  }
};
</script>

<style lang="scss">
.treeTable {
  width: 600px;
  height: 500px;
  border: undefined;
}
</style>



// WEBPACK FOOTER //
// src/views/system-manage/treeTable/DragTreeTable.vue